import routerOptions0 from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}